<div class="body-wrapper" *ngIf="gfs.loaded" [ngClass]="Direction" style='padding-top: 0;'>
    <header class="header">
        <div class="justify-between items-center" [innerHtml]="altHeader" *ngIf="altHeader && showHeader"></div>
        <div class="justify-between items-center" style="margin-bottom: 5px;">
            <h1 class="header-title">{{ 'gastro.form.type.'+gfs.form.FormName | translate }}</h1> 
            <img [src]="! print.env['haslogo'] ? '../../assets/images/logo.png' : '/api/logo'" alt="Logo"
                class="header-logo" *ngIf="print.env && ! altHeader && print.env['haslogo']">
        </div>
        <div class="header-details">
            <div *ngIf="gfs.form.FormName!=='Release Form' && gfs.form.FormName !=='Form of Consent'" style="display: inline-block; padding-left: 1em;padding-right: 1em">{{'general.ExaminationDate'| translate}}:&nbsp;<strong style='direction: ltr;'>{{gfs.form.CreationTime
                    | date:"dd.MM.yyyy HH:mm"}}</strong></div>
                    <div *ngIf="gfs.form.FormName=='Release Form'" style="display: inline-block; padding-left: 1em;padding-right: 1em"> סיום הבדיקה&nbsp;<strong style='direction: ltr;'>{{gfs.form.CreationTime
                        | date:"dd.MM.yyyy"}} {{gfs.form.EndTime}} </strong> </div>
                         <div *ngIf="gfs.form.FormName=='Form of Consent'" style="display: inline-block; padding-left: 1em;padding-right: 1em"> תאריך מילוי הטופס:  &nbsp;<strong style='direction: ltr;'>{{gfs.form.CreationTime
                            | date:"dd.MM.yyyy"}} </strong> </div>
            <div style="display: inline-block">{{'general.Printing_Date' | translate}}:&nbsp;<strong
                    style='direction: ltr;'>{{now| date:"dd.MM.yyyy HH:mm"}}</strong></div>
        </div>
    </header>
    <main class="main">
        <section class="section" *ngIf="gfs.pat">
            <h4 class="text-20 text-gold">{{(gfs.pat.Sex ? (gfs.pat.Sex == 'M' ? 'gastro.Patient.male' :
                'gastro.Patient.female'): 'gastro.Patient.details') | translate}}</h4>
            <div style="width:100%">
                <div>
                    <table>
                        <tr>
                            <td>
                                <dt>{{'general.Patient.first_name' | translate}}</dt>
                                <dd>{{gfs.pat.First}}</dd>
                            </td>
                            <td>
                                <dt>{{'general.Patient.last_name' | translate}}</dt>
                                <dd>{{gfs.pat.Last}}</dd>
                            </td>
                            <td>
                                <dt>{{'general.Patient.ID' | translate}}</dt>
                                <dd>{{gfs.pat.ID}}</dd>
                            </td>
                            <td *ngIf="gfs.pat.Mobile">
                                <dt>{{'general.Patient.mobile' | translate}}</dt>
                                <dd>{{gfs.pat.Mobile}}</dd>
                            </td>
                            <td *ngIf="gfs.pat.Sex">
                                <dt>מגדר</dt>
                                <dd>{{gfs.pat.Sex == 'M'? 'גבר': 'אישה' }}</dd>
                            </td>
                        </tr>
                        <tr *ngIf="gfs.pat.Height || gfs.pat.Weight">
                            <td *ngIf="gfs.pat.Birth">
                                <dt>{{'general.Patient.birth_date' | translate}}</dt>
                                <dd>{{gfs.pat.Birth| date:"dd.MM.yyyy"}}</dd>
                            </td>
                            <td *ngIf="gfs.pat.Birth">
                                <dt>{{'general.Patient.Age' | translate}}</dt>
                                <dd>{{gfs.pat.getAgeMo()}}</dd>
                            </td>
                            <td *ngIf="gfs.pat.Height">
                                <dt>גובה</dt>
                                <dd>{{gfs.pat.Height}}cm</dd>
                            </td>
                            <td *ngIf="gfs.pat.Weight">
                                <dt>משקל</dt>
                                <dd>{{gfs.pat.Weight}}kg</dd>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </section>
        <section class="section" *ngIf="gfs.form.Colonoscopy || gfs.form.Gastroscopy || gfs.form.Sigmoidoscopy || gfs.form.PatientIdentification||gfs.form.AdmissionTime|| gfs.form.AssignedDoctor|| gfs.form.doctor">
            <h4  *ngIf="gfs.form.Colonoscopy || gfs.form.Gastroscopy || gfs.form.Sigmoidoscopy || gfs.form.PatientIdentification" class="text-20 text-gold">בדיקה/ות שבוצעו </h4>
            <table class="l-table-auto" *ngIf="gfs.form.Colonoscopy || gfs.form.Gastroscopy || gfs.form.Sigmoidoscopy || gfs.form.PatientIdentification">
                <tr class="l-row">
                    <td class="l-td-m" *ngIf="gfs.form.PatientIdentification == 1"> <strong>{{'gastro.form.PatientIdentification' | translate}}</strong></td>
                    <td class="l-td-m" *ngIf="gfs.form.Colonoscopy == 1"> <strong>{{'gastro.form.Colonoscopy' | translate}}</strong></td>
                    <td class="l-td-m" *ngIf="gfs.form.Gastroscopy == 1"> <strong>{{'gastro.form.Gastroscopy' | translate}}</strong></td>
                    <td class="l-td-m" *ngIf="gfs.form.Sigmoidoscopy == 1"> <strong>{{'gastro.form.Sigmoidoscopy' | translate}}</strong></td>
                </tr>
            </table>
            <table class="l-table-auto">
                <tr class="l-row">
                    <td *ngIf="gfs.form.AdmissionTime">
                        <dt>
                            שעת קבלה
                        </dt>
                        <dd>{{gfs.form.AdmissionTime}}</dd>
                    </td>
                    <td *ngIf="gfs.form.AssignedDoctor">
                        <dt>
                            רופא
                        </dt>
                        <dd>{{gfs.form.AssignedDoctor}}</dd>
                    </td>
                    <td *ngIf="gfs.form.doctor">
                        <dt>
                            רופא
                        </dt>
                        <dd>{{gfs.form.doctor}}</dd>
                    </td>
                </tr>
            </table>
        </section>
        
        <section class="section" *ngIf="gfs.form.CreationTime  && (gfs.form.Temp || gfs.form.Pulse || gfs.form.Saturation || gfs.form.BloodPres || (gfs.form.bpSystolic && gfs.form.bpDyastolic) || gfs.recoveryMeas.length)">
            <h4 class="text-20 text-gold">מדדים</h4>
            <table class="l-table-auto">
                <tr class="l-row">
                    <!-- <td class="l-td-m w14"></td> -->
                    <td class="l-td-m" style="width: 10%;"><strong>{{ 'gastro.form.type.date' | translate }}</strong> </td>
                    <td class="l-td-m" style="width: 10%;"><strong>{{ 'gastro.form.type.time' | translate }}</strong></td>
                    <td class="l-td-m" style="width: 10%;"><strong>{{ 'gastro.form.type.temp' | translate }}</strong></td>
                    <td class="l-td-m" style="width: 10%;"><strong>{{ 'gastro.form.type.pulse' | translate }}</strong></td>
                    <td class="l-td-m" style="width: max-content;"><strong>{{ 'gastro.form.type.bloodpres' | translate }}</strong></td>
                    <td class="l-td-m" style="width: 10%;"><strong>{{ 'gastro.form.type.Saturation' | translate }}</strong></td>

                    <!-- <td class="l-td-m w14"></td> -->
                </tr>
                <tr class="l-row" *ngIf="gfs.form.CreationTime  && (gfs.form.Temp || gfs.form.Pulse || gfs.form.Saturation || gfs.form.BloodPres || (gfs.form.bpSystolic && gfs.form.bpDyastolic))" >
                    <!-- <td class="l-td-m w14"></td> -->
                    <td class="l-td-m center">{{gfs.form.CreationTime | date: "dd.MM.yyyy"}}</td>
                    <td class="l-td-m center">{{gfs.form.CheckTime}}</td>
                    <td class="l-td-m center" *ngIf="gfs.form.Temp">{{gfs.form.Temp}} {{'gastro.form.type.cel' | translate}}</td>
                    <td class="l-td-m center" *ngIf="gfs.form.Pulse" style="width: max-content;">{{gfs.form.Pulse}} {{'gastro.form.type.bpm' | translate}}</td>
                    <td class="l-td-m center" *ngIf="gfs.form.bpSystolic && gfs.form.bpDyastolic " style="width: max-content;">{{gfs.form.bpSystolic}}/{{gfs.form.bpDyastolic}} {{'gastro.form.type.mmHg' | translate}}</td>
                    <td class="l-td-m center" *ngIf="gfs.form.Saturation" style="width: max-content;">{{gfs.form.Saturation}}%</td>

                    <!-- <td class="l-td-m w14"></td> -->
                </tr>
                <tr class="l-row" *ngFor="let meas of gfs.recoveryMeas" >
                    <!-- <td class="l-td-m w14"></td> -->
                    <td class="l-td-m center">{{meas.CreationTime | date: "dd.MM.yyyy"}}</td>
                    <td class="l-td-m center">{{meas.CheckTime}}</td>
                    <td class="l-td-m center" *ngIf="meas.Temp">{{meas.Temp}} {{'gastro.form.type.cel' | translate}}</td>
                    <td class="l-td-m center" *ngIf="meas.Pulse" style="width: max-content;">{{meas.Pulse}} {{'gastro.form.type.bpm' | translate}}</td>
                    <td class="l-td-m center" *ngIf="meas.bpSystolic && meas.bpDyastolic " style="width: max-content;">{{meas.bpSystolic}}/{{meas.bpDyastolic}} {{'gastro.form.type.mmHg' | translate}}</td>
                    <td class="l-td-m center" *ngIf="meas.Saturation" style="width: max-content;">{{meas.Saturation}}%</td>

                    <!-- <td class="l-td-m w14"></td> -->
                </tr>
            </table>
        </section>
        <section class="section" *ngIf="gfs.form.AdmissionPainLevel">
            <tr>
                <td>
                    <dt>
                        מדד כאב
                    </dt>
                    <dd>{{translatePainLevel(gfs.form.AdmissionPainLevel)}}</dd>
        
                </td>
            </tr>
        </section>

        <ng-container *ngIf="gfs.form.data &&( gfs.form.FormName == 'Admission Form' ||gfs.form.FormName == 'Recovery Form' )">
            <section class="section" *ngIf="gfs.form.data['habits'] && gfs.form.data['habits'].length >0">
                <h4 class="text-20 text-gold" *ngIf="gfs.form.data['habits'] && gfs.form.data['habits'].length >0">
                    {{'gastro.form.Habits.title' | translate}}
                </h4>
                <table class="l-table-auto">
                    <tr *ngFor="let item of gfs.form.data['habits']">
                        <td>
                            <dt>{{item.key.displayName}}</dt>
                            <dd *ngIf="item.key.name !== 'Allergies' && item.key.name !== 'DrugsAllergies'">{{(item.value ? 'gastro.form.no' : 'gastro.form.yes') | translate}}</dd>
                            <dd *ngIf="item.key.name === 'Allergies' || item.key.name === 'DrugsAllergies'">{{(item.value ? (item.key.name === 'Allergies' ? 'gastro.form.Allergies.no' : 'gastro.form.DrugsAllergies.no' ) : (item.key.name === 'Allergies' ? 'gastro.form.Allergies.yes' : 'gastro.form.DrugsAllergies.yes' )) | translate}}</dd>
                        </td>
                        <td *ngIf="item.comment">
                            <dt>הערות</dt>
                            <dd>{{item.comment}}</dd>
                        </td>
                    </tr>
                </table>
            </section>

            <section class="section" *ngIf="gfs.form.data.preparetion && gfs.form.data.preparetion.length >0">
                <h4 class="text-20 text-gold" *ngIf="gfs.form.data['preparetion'] && gfs.form.data['preparetion'].length >0 && gfs.typeForm == 'Admission Form'">
                    {{'gastro.form.Preparation.title' | translate}}
                </h4>
                <table class="l-table-auto">
                    <tr *ngFor="let item of gfs.form.data.preparetion">
                        <td>
                            <dt>{{item.key.displayName}}</dt>
                            <dd>{{(item.value ? 'gastro.form.no' : 'gastro.form.yes') |translate}}</dd>
                        </td>
                        <td *ngIf="item.comment">
                            <dt>הערות</dt>
                            <dd>{{item.comment}}</dd>
                        </td>
                    </tr>
                </table>
            </section>
            <section class="section" *ngIf="gfs.form.data.diseases && gfs.form.data.diseases.length >0">
                <h4 class="text-20 text-gold">{{'gastro.form.diseases' | translate}}</h4>

                <table class="l-table-auto">
                    <tr *ngFor="let item of gfs.form.data.diseases">
                        <td>
                            <dt>{{item.key.displayName}}</dt>
                            <dd>{{(item.value ? 'gastro.form.no' : 'gastro.form.yes') | translate}}</dd>
                        </td>
                        <td *ngIf="item.comment">
                            <dt>הערות</dt>
                            <dd>{{item.comment}}</dd>
                        </td>
                    </tr>
                </table>
            </section>
            <section class="section" *ngIf="gfs.form.data.surgeries && gfs.form.data.surgeries.length >0">
                <table class="l-table-auto">
                    <tr *ngFor="let item of gfs.form.data.surgeries">
                        <td>
                            <dt>{{item.key.displayName}}</dt>
                            <dd>{{(item.value ? 'gastro.form.surgeries.no' : 'gastro.form.surgeries.yes') | translate}}</dd>
                        </td>
                        <td *ngIf="item.comment">
                            <dt>הערות</dt>
                            <dd>{{item.comment}}</dd>
                        </td>
                    </tr>
                </table>
            </section>
            <section class="section" *ngIf="gfs.form.data.medications && gfs.form.data.medications.length >0">
                <table class="l-table-auto">
                    <tr *ngFor="let item of gfs.form.data.medications">
                        <td>
                            <dt>{{item.key.displayName}}</dt>
                            <dd>{{(item.value ? 'gastro.form.no' : 'gastro.form.yes') | translate}}</dd>
                        </td>
                        <td *ngIf="item.comment">
                            <dt>הערות</dt>
                            <dd>{{item.comment}}</dd>
                        </td>
                    </tr>
                </table>
            </section>
            <section class="section" *ngIf="gfs.form.data.status && gfs.form.data.status.length >0">
                <h4 class="text-20 text-gold"> {{'gastro.form.status' | translate}}</h4>
                <table class="l-table-auto">
                    <tr *ngFor="let item of gfs.form.data.status">
                        <td>
                            <dt>{{item.key.displayName}}</dt>
                            <dd>{{(item.value ? 'gastro.form.no' : 'gastro.form.yes') | translate}}</dd>
                        </td>
                        <td *ngIf="item.comment">
                            <dt>הערות</dt>
                            <dd>{{item.comment}}</dd>
                        </td>
                    </tr>
                </table>
            </section>
            <section class="section" *ngIf="gfs.form.EmotionalStatus || gfs.form.GeneralComment || gfs.form.PreliminaryTraining">
                <table class="l-table-auto">
                        <td *ngIf="gfs.form.EmotionalStatus">
                            <dt>מצב רגשי</dt>
                            <dd>{{gfs.form.EmotionalStatus}}</dd>
                        </td>
                        <td *ngIf="gfs.form.GeneralComment">
                            <dt>הערה כללית</dt>
                            <dd>{{gfs.form.GeneralComment}}</dd>
                        </td>
                        <tr *ngIf="gfs.form.PreliminaryTraining">
                            <td>
                                <dt>הדרכה מקדימה </dt>
                                <dd>{{gfs.form.PreliminaryTraining}}</dd>
                            </td>
                        </tr>
                    </table>
                </section>

            <section class="section" *ngIf="gfs.form.data.recovery && gfs.form.data.recovery.length >0">
                <h4 class="text-20 text-gold"> {{'gastro. AldreteScore' | translate}}</h4>
                <table class="l-table-auto">
                    <tr *ngFor="let item of gfs.form.data.recovery">
                        <td>
                            <dt>{{item.key.displayName}}</dt>
                            <dd>{{ item.value ==0 ? item.key['value0']:item.value ==1? item.key['value1']:item.key['value2'] }}</dd>

                        </td>
                        <td *ngIf="item.comment">
                            <dt>הערות</dt>
                            <dd>{{item.comment}}</dd>
                        </td>
                    </tr>
                    <tr *ngIf="gfs.totalRecoveryScore">
                        <td>
                            <dt>סה"כ ניקוד</dt>
                            <dd>{{gfs.totalRecoveryScore}}</dd>

                        </td>
                    </tr>
                </table>
            </section>
        </ng-container>
        <ng-container *ngIf="gfs.form && gfs.form.FormName == 'Time Out Form'">
            <section class="section">
                <table class="l-table-auto">
                    <tr *ngIf="gfs.form.IdentetyMatchBreclate == 1">
                        <td>השם ומספר ת.ז תואמים לפרטי הנבדק/ת</td>
                    </tr>
                    <tr *ngIf="gfs.form.IdentetyMatchBreclate ==0">
                        <td>השם ומספר ת.ז לא תואמים לנבדק/ת</td>
                    </tr>
                    <tr *ngIf="gfs.form.Identety == 1">

                        <td>הנבדק/ת חזר/ה בקול על ת.ז,שם ושם משפחה</td>
                    </tr>
                    <tr *ngIf="gfs.form.Identety == 0">
                        <td>הנבדק/ת לא חזר/ה על ת.ז,שם ושם משפחה</td>
                    </tr>
                    <tr *ngIf="gfs.form.Guardian == 1">
                        <td>{{'gastro.form.timeout.Guardian' | translate}} <span style="margin-inline-start: 20px;"><strong style="margin-inline-end: 5px;">{{'gastro.form.timeout.details' | translate}}:</strong> {{gfs.form.GuardianName}} {{gfs.form.GuardianID}}</span></td>
                    </tr>
                     <tr *ngIf="gfs.form.IdentetyMatchDocumante  == 1">
                        <td>{{'gastro.form.timeout.IdentetyMatchDocumante' | translate}}</td>
                    </tr>
                    <tr *ngIf="gfs.form.IdentetyMatchDocumante  == 0">
                        <td>השם ומספר ת.ז לא תואמים למסמכים </td>
                    </tr>
                    <tr *ngIf="gfs.form.Prosthesis == 1">
                        <td>{{'gastro.form.timeout.Prosthesis' | translate}}</td>
                    </tr>
                    <tr *ngIf="gfs.form.Prosthesis == 0">
                        <td>ללא שיניים תותבות</td>
                    </tr>
                    <tr *ngIf="gfs.form.DAC == 1">
                        <td>{{'gastro.form.timeout.DAC' | translate}} <span style="margin-inline-start: 20px;"><strong style="margin-inline-end: 5px;">{{'gastro.form.timeout.details' | translate}}:</strong>{{gfs.form.DACComments}}  </span></td>
                    </tr>
                    <tr *ngIf="gfs.form.DAC == 0">
                        <td>ללא תרופות נגד קרישיות דם <span style="margin-inline-start: 20px;"><strong style="margin-inline-end: 5px;">{{'gastro.form.timeout.details' | translate}}:</strong>{{gfs.form.DACComments}}  </span></td>
                    </tr>
                    <tr *ngIf="gfs.form.validconcentFormSedation == 'valid'">
                        <td>טפסי הסכמה לסדציה   <span style="margin-inline-start: 20px;"><strong style="margin-inline-end: 5px;">תקין</strong></span></td>
                    </tr>
                    <tr *ngIf="gfs.form.validconcentFormSedation == 'notvalid'">
                        <td>טפסי הסכמה לסדציה   <span style="margin-inline-start: 20px;"><strong style="margin-inline-end: 5px;"> לא תקין</strong></span></td>
                    </tr>
                    <tr *ngIf="gfs.form.validconcentFormAction == 'valid'">
                        <td>טפסי הסכמה לפעולה   <span style="margin-inline-start: 20px;"><strong style="margin-inline-end: 5px;">תקין</strong></span></td>
                    </tr>
                    <tr *ngIf="gfs.form.validconcentFormAction == 'notvalid'">
                        <td>טפסי הסכמה לפעולה   <span style="margin-inline-start: 20px;"><strong style="margin-inline-end: 5px;"> לא תקין</strong></span></td>
                    </tr>
                    <tr *ngIf="gfs.form.Equipment ==1">
                        <td>{{'gastro.form.timeout.Equipment' | translate}}<span style="margin-inline-start: 20px;"><strong style="margin-inline-end: 5px;">תקין</strong>{{gfs.form.EquipmentNote}}</span></td>
                    </tr>
                    <tr *ngIf="gfs.form.Equipment ==0">
                        <td>{{'gastro.form.timeout.Equipment' | translate}}<span style="margin-inline-start: 20px;"><strong style="margin-inline-end: 5px;">לא תקין</strong>{{gfs.form.EquipmentNote}}</span></td>
                    </tr>

                    <!-- <tr *ngIf="gfs.form.isProc == 1">
                        <td>{{'gastro.form.timeout.ProcedureType' | translate}}: {{gfs.form.ProcedureType}}</td>
                    </tr> -->
                    <tr *ngIf="gfs.form.MedicationType">
                        <td>{{'gastro.form.timeout.MedicationType' | translate}}: {{gfs.form.MedicationType}}</td>
                    </tr>

                    <tr *ngIf="gfs.form.medSens">
                        <td><strong>{{'רגישות לחומרים'}}:</strong> {{gfs.form.medSens}}</td>
                    </tr>



                    
                </table>
            </section>
        </ng-container>
        <section class="section" >
          
        
            <section class="section" *ngIf="gfs.signs.length">
                <h4>סימנים חיוניים</h4>
                <table class="l-table-auto weightAss-table">
                    <tr class="l-row weightAss-thead">
                        <td class="l-td-m" style="width: 5%;">#</td>
                        <td class="l-td-m" style="width: 15%;">שעה</td>
                        <td class="l-td-m" style="width: 15%;">לחץ דם</td>
                        <td class="l-td-m" style="width: 15%;">דופק</td>
                        <td class="l-td-m" style="width: 15%;">סטורציה</td>
                    </tr>
                    <ng-container *ngFor="let sign of gfs.signs; index as i">
                        <tr class="l-row weightAss-tbody">
                            <td class="l-td-m" style="width: 5%;">
                                {{i+1}}
                            </td>
                            <td class="l-td-m" style="width: 15%;">
                                {{sign?.CreationTime | date: 'HH:mm'}}
                            </td>
                            <td class="l-td-m" style="width: 15%;">
                                {{sign?.bpSystolic}}/{{sign?.bpDyastolic}}mmHg
                            </td>
                            <td class="l-td-m" style="width: 15%;">
                                {{sign?.Pulse}}bpm
                            </td>
                            <td class="l-td-m" style="width: 15%;">
                                {{sign?.Saturation}}%
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </section>
            
            <section class="section" *ngIf="gfs.form && gfs.form.FormName == 'Course Of Exam'">
        
                <table class="l-table-auto">
                    <tr>
                        <td *ngIf="gfs.form.DeviceType ">
                            <dt>
                                סוג המכשיר
                            </dt>
                            <dd>{{gfs.form.DeviceType }}</dd>
                        </td>
                        <td *ngIf="gfs.form.DeviceNumber ">
                            <dt>
                                מספר המכשיר
                            </dt>
                            <dd>{{gfs.form.DeviceNumber }}</dd>
                        </td>

                    </tr>
                    <tr>
                        <td *ngIf="gfs.form.Sedation!=-1">
                            <dt>
                                סדציה
                            </dt>
                            <dd>{{gfs.form.Sedation==1?'כן':'לא'}}</dd>
                        </td>
                        <td *ngIf="gfs.form.MedicationType && gfs.form.Sedation==1 ">
                            <dt>
                                סוג החומר/ים
                            </dt>
                            <dd>{{gfs.form.MedicationType}}</dd>
                        </td>
                        <td *ngIf="gfs.form.MedicationText &&  gfs.form.Sedation==1  ">
                            <dt>
                                פירוט
                            </dt>
                            <dd>{{gfs.form.MedicationText}}</dd>
                        </td>
                    </tr>
                       
                    <tr>
                        <td *ngIf="gfs.form.Byopsy !== -1">
                            <dt>
                                ביופסיה
                            </dt>
                            <dd>{{gfs.form.Byopsy ? 'נלקח' : 'לא נלקח' }}</dd>
                        </td>
                    </tr>
                    <tr>
                        <td *ngIf="gfs.form.Polypectomy !== -1">
                            <dt>
                                פוליפאקטומי
                            </dt>
                            <dd>{{gfs.form.Polypectomy ? 'בוצע' : 'לא בוצע' }}</dd>
                        </td>
                    </tr>
                    <tr>
                        <td *ngIf="gfs.form.HpTaken !== -1">
                            <dt>
                                אוראז טסט (HP)
                            </dt>
                            <dd>{{gfs.form.HpTaken ? 'נלקח' : 'לא נלקח' }}</dd>
                        </td>
                        <td *ngIf="gfs.form.HpTaken == 1  && gfs.form.HpResult!==-1">
                            <dt>
                                  תוצאה
                            </dt>
                            <dd>{{gfs.form.HpResult ? 'חיובי' : 'שלילי ' }}</dd>
                        </td>
                    </tr>
                    <tr>
                        <td *ngIf="gfs.form.Spot !== -1">
                            <dt>
                                סימון בדיו (SPOT)
                            </dt>
                            <dd>{{gfs.form.Spot ? 'בוצע' : 'לא בוצע' }}</dd>
                        </td>
                    </tr>
                    <tr *ngIf="gfs.form.Plate !== -1 || gfs.form.PlateText" >
                        <td *ngIf="gfs.form.Plate !== -1">
                            <dt>
                                שימוש בפלטה
                            </dt>
                            <dd>{{gfs.form.Plate ? 'כן' : 'לא' }}</dd>
                        </td>
                        <td *ngIf="gfs.form.PlateText">
                            <dt>
                                מיקום הפלטה
                            </dt>
                            <dd>{{gfs.form.PlateText}}</dd>
                        </td>
                    </tr>
                    <tr *ngIf="gfs.form?.OpenVein !== -1">
                    <td >
                        <dt>
                            למטופל וריד פתוח
                        </dt>
                        <dd>{{gfs.form.OpenVein ? 'כן' : 'לא' }}</dd>
                    </td>
                  </tr>
                  <tr *ngIf="gfs.form?.receivesOxygen !== -1">
                    <td >
                        <dt>
                            המטופל/ת מקבל/ת חמצן במשקפיים/מסכה
                        </dt>
                        <dd>{{gfs.form.receivesOxygen ? 'כן' : 'לא' }}</dd>
                    </td>
                </tr>
                    <!-- <tr>
                        <td *ngIf="gfs.form.SkinBefore !== -1">
                            <dt>
                                מצב העור לפני
                            </dt>
                            <dd>{{gfs.form.SkinBefore ? 'תקין' : ' לא תקין' }}</dd>
                        </td>
                        <td *ngIf="gfs.form.SkinAfter !== -1">
                            <dt>
                                מצב העור אחרי
                            </dt>
                            <dd>{{gfs.form.SkinAfter ? 'תקין' : 'לא תקין' }}</dd>
                        </td>
                    </tr> -->
                    <tr>
                        <td *ngIf="gfs.form.DuringProc !== -1">
                            <dt>
                                מהלך פעולה
                            </dt>
                            <dd>{{gfs.form.DuringProc ? 'תקין' : 'לא תקין' }}</dd>
                        </td>
                        <td *ngIf="gfs.form.DuringProcText">
                            <dt>
                                פירוט
                            </dt>
                            <dd>{{gfs.form.DuringProcText}}</dd>
                        </td>
                    </tr>
                       <tr> 
                        <td *ngIf="gfs.form.PainLevel">
                            <dt>
                                מדד כאב
                            </dt>
                            <dd>{{translatePainLevel(gfs.form.PainLevel)}}</dd>
        
                        </td>
                        </tr> 
                    <tr>
                        <td *ngIf="gfs.form.EndTime">
                            <dt>
                                שעת סיום הבדיקה
                            </dt>
                            <dd>{{gfs.form.EndTime}}</dd>
                        </td>
                    </tr>
                </table>
            </section>
        
        </section>
        <!-- consent -->
        <ng-container *ngIf="gfs.form && gfs.form.FormName == 'Form of Consent'" >
            <section *ngIf="gfs.form.SedationConsent" class="section">
                <h3>הסכמה לסדציה</h3>

                <p style="display: inline;">לצורך ביצוע הפעולה הטיפולית/אבחנתית תקבל תכשיר/תרופה שיגרום לסדציה (טשטוש) המביאה לידי שיכוך כאב,הרגעה ו/או הרפיה.</p>&nbsp;
                <p style="display: inline;">סדציה גורמת להפחתת הכאב, למצב רגיעה והפחתת חרדה ופחד, כאשר המטופל שומר/ת על הכרה מלאה או יכול/ה להיות מנומנם/ת.</p>&nbsp;
                 <p style="display: inline;" >הוסבר לי תופעות הלוואי הצפויות לאחר סדציה הכוללות- בחילה, הקאה וישנוניות.</p>&nbsp;
                 <p  style="display: inline;">אני מצהיר/ה ומאשר/ת בזאת כי הוסברו לי סיבוכים האפשריים, הכוללים בין היתר, דיכוי נשימה עקב מתן נוזלים ו/או תרופות לווריד.</p>&nbsp;
                 <p style="display: inline;">במקרים נדירים עלולים להופיע הזיות, תגובה אלרגית, חום, פריחה ובמקרים נדירים מאוד דום לב או תרדמת. תתכן אפשרות של צורך באשפוז להשגחה והמשך טיפול.</p>&nbsp;
                 <p style="display: inline;">אצל אישה בהריון, יתכן מעבר של חלק מחומרי הסדציה לעובר, ויתכנו,  במקרים נדירים תופעות לוואי וסיבוכים לעובר או להמשך ההריון.</p>&nbsp;
                <p style="display: inline;">הוסבר לי שיתכן כשולונות בביצוע הסדציה, המחייב לעיתים מתן טיפולים להבטחת פעילות המערכת החיונית, ועד ביצוע פעולות לצורך הצלת חיים.</p>&nbsp;
                <p style="display: inline;">הובהר לי כי במקרה כזה יתכן ולא תתבצע הפעולה המתוכננת.</p>
            </section>
            <section class="section" *ngIf="gfs.form.EndoscopyConsent">
                <h3>הסכמה לאנדוסקופיה</h3>
    
                <p>האנדוסקופ הוא צינור גמיש שבתוכו מצויים סיבים אופטיים, דרכם ניתן לראות, ותעלות דרכן ניתן להעביר מכשירים לצורך לקיחת ביופסיות, כריתת פוליפים, צריבת נקודות דמם, טיפול בדליות והוצאת גוף זר.</p>
                <p>אורכו של האנדוסקופ נע בין 1.20 ל1.80. קוטרו 1 ס"מ, וניתן בעזרתו לבדוק את מערכת העיכול העליונה והתחתונה. בדרך כלל, לפני הבדיקה, מקבל הנבדק תתרופות הרגעה ו/או אלחוש מקומי, על מנת להפחית את תחושת אי הנוחות שבבדיקה. </p>
                <p>הבדיקה מבוצעת כאשר הנבדק/ת שוכב/ת על צד שמאל. כאשר מדובר בבדיקה של דרכי עיכול עליונות  </p>
                <p  style="display: inline;">  (אזופגוסקופיה, גסטרוסקופיה ) מוחדר האנדוסקופ דרך הפה.</p>
                <p  style="display: inline;"> כאשר מדובר בבדיקה של דרכי עיכול תחתונות (סיגמואידוסקופיה,קולונוסקופיה) מוחדר האנדוסקופ דרך פי הטבעת.</p>
                <p>בהמשך מוחדרים דרכו מכשירים בהתאם לפעולות הנדרשות. משך הבדיקה נע, בדרך כלל, בין 15 דקות לשעה. במשך הבדיקה קיימת הרגשה של אי נוחות ונפיחות בבטן.</p>
                <p>הוסבר לי על קיומן של חלופות אבחנתיות, יתרונן, חסרונן, תופעות הלוואי שלהן והסיבוכים האפשריים.</p>
                <p style="display: inline;">אני מצהיר/ה ומאשר/ת בזאת כי הוסברו לי תופעות הלוואי של הטיפול העיקרי לרבות כאב, אי נוחות ותחושה של נפיחות בבטן.</p>&nbsp;
                <p style="display: inline;">כמו כן, הוסברו לי הסיבוכים האפשריים לרבות: דימום או קרע של דופן מערכת העיכול, אשר בחלק מהמקרים יצריכו תיקון ניתוחי.</p>&nbsp;
                <p style="display: inline;">בבדיקת דרכי עיכול עליונות עלול להיגרם נזק לשיניים עקב החדרת המכשיר דרך הפה. הסיבוכים האמורים אינם שכיחים.</p>
                <p>אני נותן/ת בזאת את הסכמתי לביצוע הטיפול העיקרי.</p>
                <p>כמו כן, אני מצהיר/ה ומאשר/ת בזאת כי הוסבר לי ואני מבין/ה שקיימת אפשרות שתוך ביצוע הטיפול העיקרי או מיד לאחריו יתברר שיש צורך להרחיב את היקפו, לשנותו או לנקוט בהליכים אחרים או נוספים לצורך הצלת חיים או למניעת נזק גופני, לרבות פעולות כירוגיות שלא ניתן לצפותם כעת בוודאות או במלואם, אך משמעותם הובהרה לי.</p>
                <p>לפיכך אני מסכים/ה גם לאותה הרחבה,  שנוי או ביצוע הליכים אחרים או נוספים, לרבות פעולות כירוגיות שלדעת רופאי המוסד יהיו חיוניים או דרושים במהלך הטיפול העיקרי או מיד לאחריו.</p>
                <p>הסכמתי ניתנת בזאת גם למתן תרופות הרגעה ואלחוש מקומי לאחר שהוסבר לי שהשימוש בתרופות הרגעה עלול לגרום,לעיתים נדירות,להפרעות בנשימה והלהפרעות בפעילות הלב בעיקר אצל חולי לב וחולי מערכת הנשימה, וכן הסיכון האפשרי של תגובה אלרגית בדרגות שונות לחומר המאלחש.</p>
                <p>אני יודע/ת ומסכים/ה לכך שהטיפול העיקרי וכל ההליכים האחרים ייעשו ביד מי שהדבר יוטל עליו, בהתאם לנהלים ולהוראות של המוסד וכי לא הובטח לי שייעשו, כולם או חלקם, בידי אדם מסויים, ובלבד שייעשו באחריות המקובלת במוסד בכפוף לחוק.</p>
    

          </section>
          <section class="section">
            <p style="display: inline;">הוסבר לי על הצורך בביצוע <strong>{{getExamPerformedString()}} </strong> אבחונית ו/או טיפולית לרבות לקיחת ביופסיה, כריתת פוליפים, צריבת נקודות דמם, טיפול בדליות והוצאת גוף זר. </p>
           <p style="display: inline-block;" *ngIf="gfs.form.otherTreatment"> פרט טיפול אחר {{gfs.form.otherTreatment}}</p>
             <p *ngIf="gfs.form.otherTreatment" style="display: inline-block;"> (להלן: "הטיפול העיקרי") </p> 
          </section>
          <section class="section">
          <h2>אני מצהיר/ה ומאשר/ת בזאת שקיבלתי הסבר מפורט בעל פה מ{{gfs.form.doctor}}</h2>
          <div style="display: block;">יום:{{ gfs.form.CreationTime | date: 'EEEE' | translateDay }} תאריך: {{gfs.form.CreationTime
            | date:"dd.MM.yyyy"}} שעה: {{ gfs.form.CreationTime | date: "HH:mm" }}</div>
          <ng-container *ngIf="gfs.form.patSign && !gfs.form.Guardian" >
            <span style="align-self: flex-end; width: 20%; vertical-align: top;">{{ 'חתימת המטופל/ת' }}:</span>
            <img style="height: 6em;align-self: end;" [src]="gfs.form.patSign" alt="Image Description">
        </ng-container>
        <ng-container *ngIf="gfs.form.Guardian" >
            <span style="align-self: flex-end; width: 20%; vertical-align: top;"> שם האפוטרופוס: {{  gfs.form.GuardianName }}  חתימת האפוטרופוס: </span>
            <img style="height: 6em;align-self: end;" [src]="gfs.form.guardianSign" alt="Image Description">
        </ng-container>
        <h2>אני מאשר שהסברתי לחולה/לאפוטרופוס של החולה את כל האמור לעיל בפירוט הדרוש כי הוא/היא חתם על הסכמה בפני לאחר ששוכנעתי כי הבין/נה את כל הסברי במלואם</h2>
        <div style="display: block;">יום:{{ gfs.form.CreationTime | date: 'EEEE' | translateDay }} תאריך: {{gfs.form.CreationTime
            | date:"dd.MM.yyyy"}} שעה: {{ gfs.form.CreationTime | date: "HH:mm" }}</div>
        <ng-container *ngIf="gfs.form.docSign" >
            <span style="align-self: flex-end; width: 20%; vertical-align: top;"> שם הרופא:  {{  gfs.form.doctor }} מספר רשיון:  {{gfs.form.docLicense}} חתימת הרופא:</span>
            <img style="height: 6em;align-self: end;" [src]="gfs.form.docSign" alt="Image Description">
        </ng-container>

          </section>


        </ng-container>
        <!-- consent end -->
        <ng-container *ngIf="gfs.form && gfs.form.FormName == 'Release Form'">
            <section class="section">
                <table class="l-table-auto">
                    <tr *ngIf="gfs.form.consciousState == 'awake'">
                        <td><strong>מצב הכרה:</strong> ער/ה</td>
                    </tr>
                    <tr *ngIf="gfs.form.consciousState == 'sleepy'">
                        <td><strong>מצב הכרה:</strong> מנומנם/ת</td>
                    </tr>
                    <tr *ngIf="gfs.form.consciousState == 'dormant'">
                        <td><strong>מצב הכרה:</strong> רדום</td>
                    </tr>
                    <tr *ngIf="gfs.form.providingDrink ==0">
                        <td><strong>מתן שתייה:</strong>לא</td>
                    </tr>
                    <tr *ngIf="gfs.form.providingDrink ==1">
                        <td><strong>מתן שתייה:</strong>כן</td>
                    </tr>
                    <tr *ngIf="gfs.form.InstructionRelease ==0">
                        <td><strong>הדרכה :</strong>לא</td>
                    </tr>
                    <tr *ngIf="gfs.form.InstructionRelease ==1">
                        <td><strong>הדרכה :</strong>כן</td>
                    </tr>
                    <tr *ngIf="gfs.form.Dentures ==0">
                        <td><strong>שיניים תותבות :</strong>לא</td>
                    </tr>
                    <tr *ngIf="gfs.form.Dentures ==1">
                        <td><strong>שיניים תותבות :</strong>כן</td>
                    </tr>
                    <tr *ngIf="gfs.form.Dentures ==2">
                        <td><strong>שיניים תותבות :</strong>לא רלוונטי</td>
                    </tr> 
                    <tr *ngIf="gfs.form.personalEquipment ==0">
                        <td><strong>ציוד אישי :</strong>לא</td>
                    </tr>
                    <tr *ngIf="gfs.form.personalEquipment ==1">
                        <td><strong>ציוד אישי :</strong>כן</td>
                    </tr>
                    <tr *ngIf="gfs.form.TakeOutVanaflon ==0">
                        <td><strong>הוצאת ונפלון :</strong>לא</td>
                    </tr>
                    <tr *ngIf="gfs.form.TakeOutVanaflon ==1">
                        <td><strong>הוצאת ונפלון :</strong>כן</td>
                    </tr>
                    <tr *ngIf="gfs.form.accompanied ==0">
                        <td><strong> האם יש מלווה:</strong>לא</td>
                    </tr>
                    <tr *ngIf="gfs.form.accompanied ==1">
                        <td><strong>האם יש מלווה:</strong>כן</td>
                    </tr>
                </table>
            </section>

        </ng-container>
    <!-- ============== Signature (Start) ============== -->
    @if (gfs.form && gfs.form.FormName != "Form of Consent") {
      <section style="display: flex">
        @if (gfs.form.ReleaseTime || gfs.form.nurseSign) {
          <div
            class="section"
            style="
              width: 100%;
              display: flex;
              gap: 1em;
              margin: 0;
              flex-wrap: wrap;
              padding: 1em;
              align-items: flex-start;
            "
          >
            @if (gfs.form.ReleaseTime) {
              <span
                style="align-self: flex-end; width: 20%; vertical-align: bottom"
              >
                {{ "שעת שחרור" }}:
              </span>
              <span
                style="
                  align-self: flex-end;
                  vertical-align: bottom;
                  border-bottom: 1px solid black;
                  margin-left: 3%;
                "
              >
                {{ gfs.form.ReleaseTime }}
              </span>
            }
            <span>
              <span style="align-self: end; width: 20%; vertical-align: bottom">
                <strong> {{ "ממלא הטופס" }}: </strong>
              </span>
              <span
                style="
                  align-self: end;
                  vertical-align: bottom;
                  border-bottom: 1px solid black;
                  width: 20%;
                  white-space: nowrap;
                "
              >
                {{
                  gfs.form.ResponsibleForm ||
                    gfs.signers[0]["Title"] + " " + gfs.signers[0].Name
                }}
              </span>
            </span>
            @if (gfs.form.nurseSign) {
              <div>
                <div style="display: flex; flex-direction: column">
                  <span>
                    <strong style="white-space: nowrap">
                      {{ "חתימת האח/ות" }}:
                    </strong>
                  </span>
                  <img
                    style="
                      height: 50%;
                      align-self: end;
                      border: 1px black solid;
                      border-radius: 5px;
                    "
                    [src]="gfs.form.nurseSign"
                    alt="Nurse signature"
                  />
                </div>
                @if (gfs.signers?.[0]?.NurseNum) {
                  <div
                    style="
                      align-self: flex-end;
                      vertical-align: bottom;
                      margin-right: 1%;
                      white-space: nowrap;
                    "
                  >
                    <strong>
                      {{ "summary.doctor.licensenumber" | translate }}
                    </strong>
                    <span>
                      {{ gfs.signers[0].NurseNum }}
                    </span>
                  </div>
                }
              </div>
            }
            @if (gfs.form.doctorSign) {
            <div>
                <div style="display: flex; flex-direction: column">
              <span>
                <strong style="white-space: nowrap">
                    {{ "חתימת הרופא/ה" }}:
                </strong>
              </span>
              <img
               style="
                      height: 50%;
                      align-self: end;
                      border: 1px black solid;
                      border-radius: 5px;
                    "
                [src]="gfs.form.doctorSign"
                alt="חתימת הרופא/ה"
              />
            </div>
            </div>
            }
          </div>
        }
        @if (gfs.form.FormName == "Admission Form") {
          <div
            class="section"
            style="
              width: 50%;
              display: flex;
              margin: 0 0.5em 0 0;
              vertical-align: bottom;
              gap: 1.5em;
              padding: 1em;
            "
          >
            <span
              style="
                align-self: end;
                width: 30%;
                vertical-align: bottom;
                white-space: nowrap;
              "
            >
              <strong> {{ "gastro.form.patsign" | translate }}: </strong>
            </span>
            <span
              style="
                min-height: 100%;
                width: 70%;
                border-bottom: 1px solid black;
              "
            ></span>
          </div>
        }
      </section>
    }
    <!-- ============== Signature (End) ============== -->

        <!-- <section class="section"*ngIf="gfs.form.FormName == 'Recovery Form'">
            <table>
                <tr *ngFor="let signer of gfs.signers;let i = index">
                    <td class="w-1/3"><strong>{{(signer['Title'] ? signer['Title']+ ' ': '')+ signer.Name}}</strong>
                    </td>
                    <td class="w-1/3">
                        <ng-container *ngIf="signer.DrNum">מ.ר. <strong>{{signer.DrNum}} </strong></ng-container>
                        <ng-container *ngIf="signer.ExpertNum">מ.ר.מ. <strong>{{signer.ExpertNum}}</strong>
                        </ng-container>
                    </td>
                    <td class="w-1/3" *ngIf="i == 0">{{'general.ExaminationDate' | translate}}: <strong>{{gfs.form.CreationTime | date:"dd.MM.yyyy"}}</strong></td>
                </tr>
            </table>
        </section> -->
        <p class="comment" class="finished" *ngIf="loaded"></p>
    </main>
</div>